import moment from 'moment-timezone/builds/moment-timezone-with-data';

export const getTimeZoneList = () => {
    return moment.tz.names();
}